/** Türkçe sözlük · sanal. Şekli bu dosya tanımlar; öteki diller ona bağlıdır. */
export const sanal = {
  sabitNot:
    "Sanal hesap geçmişi kuraldan yeniden kurar: geçmiş sonuç geleceği göstermez; vergi hesaba girmez; " +
    "kapanmış ya da artık izlenmeyen fonlar listede olmadığı için geniş seçimler olduğundan iyi görünebilir.",

  ekran: {
    baslik: "Sanal Hesaplar",
    kisaAciklama: "Geriye dönük deneme.",
    aciklama:
      "Geriye dönük deneme: bir kural tanımlayın, hareketler geçmiş fiyatlarla kuraldan kurulsun. Gerçek kasanıza hiçbir şey yazılmaz.",
    derlemedeYok: "Bu derlemede sanal hesap yok",
    derlemedeYokAciklama: "Gerçek cihaz deposuyla açın.",
    dosyadanAl: "Dosyadan al",
    yeni: "Yeni sanal hesap",
    varOlanlarSilinmedi: "Var olan sanal hesaplarınız silinmedi.",
    kuralKaydedilmedi: "Kural kaydedilmedi.",
    kaydedildiFiyatlar: (ad: string) => `"${ad}" kaydedildi. Fiyatlar sunucudan alınıyor…`,
    kaydedildiUyari: (ad: string, uyarilar: string) => `"${ad}" kaydedildi. Fiyat alınırken uyarı: ${uyarilar}`,
    kaydedildi: (ad: string) => `"${ad}" kaydedildi.`,
    paylasilanEklenmedi: "Paylaşılan kural eklenmedi",
    okunuyor: "Sanal hesaplar okunuyor…",
    bosBaslik: "Henüz sanal hesap yok",
    bosAciklama:
      "Örneğin: üç yıl önce başlayıp her ay aynı tutarla %60 hisse, %40 altın alsaydınız bugün ne olurdu?",
    liste: "Sanal hesaplar",
    bugun: "bugün",
    varlikDokumu: "Varlık Dökümü",
    gunlukAnaliz: "Günlük Analiz",
    duzenle: "Düzenle",
    kopyala: "Kopyala",
    paylasimUcretli: "Paylaşım ücretli bir kabiliyet (Abonelik).",
    paylas: "Paylaş",
    yenidenKaristir: "Yeniden karıştır",
    silmeyiOnayla: "Silmeyi onayla",
    vazgec: "Vazgeç",
    sil: "Sil",
  },

  renk: {
    mavi: "Mavi",
    lacivert: "Lacivert",
    mor: "Mor",
    eflatun: "Eflatun",
    turkuaz: "Turkuaz",
    petrol: "Petrol",
    kahverengi: "Kahverengi",
    gri: "Gri",
  },

  form: {
    yeni: "Yeni sanal hesap",
    duzenleEtiket: "Sanal hesabı düzenle",
    duzenleBaslik: (ad: string) => `Düzenle: ${ad}`,
    ad: "Ad",
    renk: "Renk",
    renksiz: "Renksiz",
    paraBirimi: "Hesabın para birimi",
    paraBirimiIpucu: "Yatırılan ve çekilen tutarların para birimi.",
    varliklar: "Varlıklar ve hedef oranlar",
    listeAlinamadi: "Sunucudaki varlık listesi alınamadı",
    listeAlinamadiMetin: "Yalnızca döviz seçilebilir. Bağlantı gelince sayfayı yeniden açın.",
    varlik: "Varlık",
    oran: "Oran %",
    kusuratIpucu: "Küsuratlı (kesirli adet) alınabilir mi",
    kusurat: "Küsurat",
    kilitliIpucu: "Satarak dengelemede hiç satılmaz",
    kilitli: "Kilitli",
    cikar: "Çıkar",
    oranEtiket: (ad: string) => `${ad} oranı (yüzde)`,
    kusuratEtiket: (ad: string) => `${ad} küsuratlı alınabilir`,
    kilitliEtiket: (ad: string) => `${ad} kilitli`,
    toplam: "Toplam:",
    esitDagit: "Eşit dağıt",
    varlikEkle: "Varlık ekle",
    varlikEkleIpucu: "Sembol ya da adla arayın (sunucunun izlediği liste ve döviz).",
    bulunanlar: "Bulunan varlıklar",
    baslangic: "Başlangıç",
    baslangicIpucu: "Bütün varlıkların fiyatı bu günde olmalı.",
    bitis: "Bitiş (isteğe bağlı)",
    bitisIpucu: "Boşsa hesap bugüne kadar ilerler.",
    paraAkisi: "Para akışı",
    duzenliAlim: "Düzenli alım",
    defterAkisi: "Gerçek hesaplarımın para akışı (aynı gün, aynı tutar)",
    baslangicTutari: "Başlangıç tutarı (isteğe bağlı)",
    periyotTutari: "Her periyotta alım tutarı",
    periyotTutariIpucu: "Komisyon dahil aşılmaz.",
    periyot: "Periyot",
    periyotBirimi: "Periyot birimi",
    gunde: "günde 1",
    haftada: "haftada 1",
    ayda: "ayda 1",
    duzenliCekim: "Düzenli çekim (başlayınca düzenli alım durur)",
    cekimTutari: "Her periyotta çekim",
    cekimBaslangici: "Çekim başlangıcı",
    defterAciklama:
      "Seçilen hesaplardaki para yatırma/çekme hareketleri (yoksa alış ve satış tutarları) aynı gün sanal hesaba yatırılır.",
    komisyon: "Komisyon (işlem başına, alış ve satışta)",
    komisyonAciklama:
      "Yüzde + sabit tutar, sonra en az / en çok sınırı. Örnek: yalnızca sabit 1,5 $; ya da %0,1, en az 0,75 $. Boş bırakılan kullanılmaz.",
    yuzde: "Yüzde %",
    sabitTutar: "Sabit tutar",
    enAz: "En az",
    enCok: "En çok",
    tutarParasi: "Tutarların para birimi",
    tutarParasiIpucu: "İşlem günü kuruyla varlığın para birimine çevrilir.",
    hesabinParasi: (para: string) => `Hesabın para birimi (${para})`,
    kaymaGeri: "Alım gününe kayma: geri (gün)",
    kaymaIleri: "İleri (gün)",
    kaymaIpucu: "Her periyotta rastlantısal; tohumla sabit.",
    temettu: "Temettü",
    ayniVarlik: "Aynı varlığa yeniden yatır",
    sonrakiAlim: "Bir sonraki alıma ekle",
    yokSay: "Yok say (fiyat getirisi)",
    temettuKomisyonu: "Temettü yeniden yatırılırken de komisyon alınsın",
    artanSonrakiAlima: "Alımda artan nakit (bir adete ya da komisyona yetmeyen) bir sonraki alıma eklensin",
    dengeleme: "Dengeleme",
    dengelemeYok: "Yok: her alımda aynı oran",
    dengelemeAlimla: "Alımla: önce hedef oranı büyük olana, para yettiğince",
    dengelemeSatarak: "Satarak: eşiği aşanı sat (kilitliler hariç)",
    esik: "Dengeleme eşiği (yüzde puanı)",
    kaydet: "Kaydet",
    farkliKaydet: "Farklı kaydet",
    vazgec: "Vazgeç",
  },

  /** Formun alan başına hataları (`lib/sanalForm.ts`). */
  hata: {
    ad: "Bir ad verin.",
    enAzBirVarlik: "En az bir varlık seçin.",
    enCokVarlik: (n: number) => `En çok ${n} varlık.`,
    oranBicimi: "Oranları yüzde olarak girin (ör. 40 ya da 33,33).",
    oranToplami: (toplam: string) => `Oranların toplamı %${toplam}; tam %100 olmalı.`,
    oranSifir: "Her varlığın oranı sıfırdan büyük olmalı.",
    baslangic: "Başlangıç tarihini seçin.",
    bitis: "Bitiş başlangıçtan önce olamaz.",
    periyot: (enCok: number) => `1 ile ${enCok} arasında bir tam sayı.`,
    tutar: "Geçerli bir tutar girin.",
    tutarYok: "Başlangıç tutarı ya da periyot tutarı girin.",
    cekimSifir: "Çekim tutarı sıfırdan büyük olmalı.",
    cekimBaslangic: "Çekimin başlangıç tarihini seçin.",
    cekimOnce: "Çekim hesabın başlangıcından önce başlayamaz.",
    gercekHesap: "En az bir gerçek hesap seçin.",
    komisyon: "Komisyonu yüzde olarak girin (ör. 0,2).",
    enCokEnAz: "En çok, en azdan küçük olamaz.",
    esik: "Eşiği yüzde puanı olarak girin (ör. 3).",
    kayma: (enCok: number) => `0 ile ${enCok} gün arasında.`,
  },

  /** Kuralın tek satırlık özeti (`lib/sanalHesap.ts`). */
  ozet: {
    /** Düzenli akış: "her ay 1000 TRY", "2 haftade bir 500 USD". */
    duzenli: (adim: number, birim: string, tutar: string, para: string) =>
      `${adim === 1 ? "her" : `${adim}`} ${({ gun: "gün", hafta: "hafta", ay: "ay" } as Record<string, string>)[birim] ?? birim}${adim === 1 ? "" : "de bir"} ${tutar} ${para}`,
    defter: "gerçek hesapların para akışıyla",
    dengelemeYok: "dengeleme yok",
    dengelemeAlimla: "alımla dengeleme",
    dengelemeSatarak: "satarak dengeleme",
    satir: (varlik: number, akis: string, dengeleme: string) => `${varlik} varlık · ${akis} · ${dengeleme}`,
    temettuHaric: " · temettü hariç",
  },

  /** Paylaşım paneli ve gelen kural (`components/SanalPaylasim.tsx`). */
  paylasim: {
    panelEtiket: (ad: string) => `${ad} paylaşımı`,
    aciklama:
      "Paylaşılan: kural (rastlantı tohumu dahil), ad ve renk. Sonuç paylaşılmaz; alan kişi kendi cihazında aynı sonucu hesaplar. Kural linkin “#” sonrasında durur, sunucuya hiç gitmez; link süresizdir.",
    defterNotu: " Para akışınızın kaynağı olan gerçek hesaplarınız paylaşılmaz.",
    link: "Paylaşım linki",
    kopyala: "Linki kopyala",
    qrGizle: "QR'ı gizle",
    qrGoster: "QR göster",
    dosyaIndir: "Dosya olarak indir",
    kopyalandi: "Link kopyalandı.",
    panoIzinYok: "Tarayıcı panoya yazmaya izin vermedi; linki alandan seçip kopyalayın.",
    qrEtiket: (ad: string) => `${ad} paylaşım linkinin QR'ı`,
    gelenBaslik: "Paylaşılan sanal hesap",
    zatenVar: (ad: string) => ` (kasanızda “${ad}” zaten var)`,
    bugun: "bugün",
    bBaslik: "Para akışı sizin hesaplarınızdan",
    bMetin:
      "Bu kuralın parası paylaşanın gerçek hesaplarından geliyordu; o hesaplar ve para girişleri paylaşılmaz. Eklerken para akışını kendi hesaplarınıza bağlayın ya da düzenli akış seçin.",
    cihazinizda: "Sonuç sizin cihazınızda, kendi fiyat arşivinizle hesaplanır.",
    eklenmedi: "Bu kural kasanıza eklenmedi.",
    ekleUc: "Sanal hesaplara ekle…",
    ekle: "Sanal hesaplara ekle",
    vazgec: "Vazgeç",
  },

  /** Paylaşılan kuralın okunamama sebepleri (`lib/sanalPaylasim.ts`). */
  okuma: {
    yeniSurum: "Bu link Parafon'un daha yeni bir sürümünden; uygulamayı güncelleyin.",
    linkBozuk: "Link bozuk: kural okunamadı.",
    bicimDegil: (yer: string) => `Kural okunamadı: ${yer} beklenen biçimde değil.`,
    taninmayanAlan: (alan: string, yeniSurum: string) => `Bu linkte tanınmayan bir alan var (${alan}). ${yeniSurum}`,
    eksik: (alan: string) => `Kural eksik: ${alan} yok.`,
    metinOlmali: (yer: string) => `Kural okunamadı: ${yer} metin olmalı.`,
    tamSayiOlmali: (yer: string) => `Kural okunamadı: ${yer} tam sayı olmalı.`,
    bayrakOlmali: (yer: string) => `Kural okunamadı: ${yer} doğru/yanlış olmalı.`,
    taninmayanDeger: (yer: string, deger: string, yeniSurum: string) =>
      `Bu linkte tanınmayan bir değer var (${yer}: ${deger}). ${yeniSurum}`,
    varliklarListe: "Kural okunamadı: varliklar liste olmalı.",
    paylasimDegil: "Bu bir Parafon sanal hesap paylaşımı değil.",
    yerPaylasim: "paylaşım",
  },

  /** Varlık Dökümü'ndeki sanal hesap notları (`components/SanalNotlar.tsx`). */
  notlar: {
    bolum: "Sanal hesap",
    uretilemedi: "Hareketler üretilemedi",
    eksikler: "Sonucu etkileyen eksikler",
    bekleyenNakit: "Alımda kullanılmayıp bekleyen nakit:",
    gizle: "Hareketleri gizle",
    goster: (n: number) => `Kuraldan türetilen ${n} hareketi göster`,
    tabloBaslik: "Sanal hesabın hareketleri (salt okunur)",
    tarih: "Tarih",
    tur: "Tür",
    varlik: "Varlık",
    miktar: "Miktar",
    fiyatTutar: "Fiyat / tutar",
    komisyon: "Komisyon",
    nakit: "Nakit",
  },
};
